import React from "react";

import Presentation from "./presentation";

const Component = props => {
	return (
		<Presentation
			{ ...props }
		/>
	);
};

export default Component;
